export const FAILED = 'role/failed';
export const LOADING = 'role/loading';
export const SUCCESS = 'role/success';
export const SET_DATA = 'role/set_data';
export const DOWNLOAD_FAILED = 'user/download/failed';
export const DOWNLOAD_LOADING = 'user/download/loagding';
export const DOWNLOAD_SUCESS = 'user/download/successs';
